<template>
  <Modal :id="'cmp-accounting-costs-add_release'" @cancelled="onCancel">
    <template slot="header">{{ $t("release") }} </template>
    <template slot="body">
      <SearchList
        :id="'releases'"
        :items="items"
        :keyProperty="'release_id'"
        :label="'release_artist'"
        :placeholder="'Search'"
        :selectionNumber="'radio'"
        :headers="[
          {
            text: $t('release_title'),
            value: 'release_title',
          },
          {
            text: $t('release_artist'),
            value: 'release_artist',
          },
          {
            text: $t('release_code'),
            value: 'identifier',
          },
          {
            text: $t('label'),
            value: 'label_name',
          },
        ]"
      >
        <template v-slot:item="{ item }">
          <tr class="dt-table2--row" @click="onContactItemClick(item)">
            <td class="dt-table2--column">
              <span class="txtov">{{ item.release_title }}</span>
            </td>
            <td class="dt-table2--column">
              <span class="txtov">{{ item.release_artist }}</span>
            </td>
            <td class="dt-table2--column">
              <span class="txtov">{{ item.identifier }}</span>
            </td>
            <td class="dt-table2--column">
              <span class="txtov">{{ item.label_name }}</span>
            </td>
          </tr>
        </template>
      </SearchList>
      <div class="form-group">
        <TextField
          :id="'description'"
          v-bind="textFieldConfig"
          :placeholder="$t('description')"
          required
          showValidationIcons
          @valuechanged="onTextFieldValueChange"
          v-model="newData.description"
          @validated="onValidation"
        ></TextField>
        <div class="amount-container">
          <TextField
            :id="'amount'"
            @valuechanged="onTextFieldValueChange"
            v-bind="textFieldConfig"
            :placeholder="$t('amount')"
            @validated="onValidation"
            required
            class="m1 input_box"
            type="text"
            showValidationIcons
            v-model="newData.amount"
          ></TextField>

          <span class="currency">{{ selectedCostsDetails.currency_iso }}</span>
        </div>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 with-ico s6"
        @click.stop="onClickOK"
      >
        <div class="button-text">
          {{ $t("ok") }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import { AccountingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { costsActions } from "../../store/costs/actions";
import SearchList from "@dtplugins/search-list/search-list";
import InputField from "@plugins/text-field/input-field";
import TextField from "@plugins/text-field/text-field";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { addRemoveSet } from "../../../../utility";
import { CostsService } from "../../services/costs.service";
import { createTV, tv } from "../../../../models/text-value.model";
import { format } from "date-fns";
import Modal from "@dtplugins/modal/modal";
import { EventHooks } from "../../../../plugins/text-field";
export default {
  components: {
    InputField,
    TextField,
    Modal,
    SearchList,
  },
  props: ["selectedCostsDetails"],
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
      validationResult: {},
      newData: {
        description: "",
        amount: "",
        external_id: 0,
      },
      releases: [],
      releaseData: {},
      invoiceDateMenu: null,
    };
  },
  mounted: function () {
    this.getReleases();
    this.getAddReleaseData();
  },
  watch: {},
  computed: {
    items: function () {
      return this.releases || [];
    },

    isFormValid: function () {
      return this.newData.description && this.newData.amount;
    },
  },
  methods: {
    ...mapActionObject(storeNS, costsActions),
    onCancel() {
      this.$emit("cancelled");
    },
    getReleases() {
      CostsService.searchCostSplitAddReleases("").then((res) => {
        this.releases = res.data.releases;
      });
    },
    async getAddReleaseData() {
      const res = await CostsService.findCostSplitAddProducts(
        this.selectedCostsDetails?.invoice?.invoice_id
      );
      this.releaseData = res.data;
      this.newData.description = res.data.invoice.subject;
    },
    onClickOK() {
      let params = {
        invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
        external_table: "release",
        description: this.newData.description,
        amount: this.newData.amount,
        external_id: this.newData.external_id,
      };

      CostsService.addNewCostSplit(params).then((res) => {
        this[ActionTypes.AccountingCostSplits.SET.ALL]({
          invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
          cost_splits: res.data.cost_splits || [],
        });
        this.onCancel();
      });
    },

    onContactItemClick: function (release) {
      this.newData.external_id = release.release_id;

      if (release) {
        let subject = release.release_artist + " / " + release.release_title;
        if (this.releaseData?.contact?.company_name) {
          subject += " - " + this.releaseData.contact.company_name;
        }

        if (this.releaseData?.invoice) {
          subject += " - " + this.releaseData.invoice.subject;
        }
        this.newData.description = subject;
      }
    },
    onValidation: function (id, validationResult) {
      // console.log(id, validationResult);
    },
    onTextFieldValueChange: function (name, value) {
      this.newData[name] = value;
      console.log("newData", this.newData);
    },
    onDropdownChange: function (name, value) {
      this.newData[name] = value.value;
    },
  },
};
</script>

<style lang="scss">
.cmp-accounting-costs-add_release {
  .dt-table2 {
    --body-height: 200px !important;
  }
  padding: 40px 55px 30px !important;
  .amount-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .currency {
      position: absolute;
      right: 4px;
      text-align: center;
      padding-bottom: 5px;
      font-weight: bold;
    }
  }
  .dt-input-box--container {
    flex: 1;
    margin: 2px 2px 12px 0px !important;
  }
}
</style>
